import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { INSIGHTSDATA } from './Insights.constants';
import {
  StyledContainer,
  StyledContent,
  StyledImage,
  StyledItem,
  StyledList,
  StyledTitle,
  StyledWrapper
} from './Insights.styled';

const Insights: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  const insightsData = INSIGHTSDATA(t, locale);

  return (
    <StyledWrapper>
      <StyledContainer>
        <Heading1 as="h4" editorial alignLeft>
          {t('mantechcar24.insights.title')}
        </Heading1>
        <StyledList>
          {insightsData.map((item, index) => (
            <StyledItem key={index}>
              <StyledImage src={item.image} alt="" />
              <StyledContent>
                <StyledTitle>{item.title}</StyledTitle>
                <p>{item.text}</p>
                <ButtonLink
                  href={locale === 'es' ? item.url_es : item.url_en}
                  variant="secondary"
                >
                  <span>{t('mantechcar24.insights.keep-reading')}</span>
                  <FontAwesomeIcon icon={faArrowRight} />
                </ButtonLink>
              </StyledContent>
            </StyledItem>
          ))}
        </StyledList>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Insights;
